const URLs = {
  GET_LIST: 'posts',
  CREATE_OVB: '/obv/plaid',
  LOOKUP_TRANS_DATA: '/obv/plaid/lookupTransactionData',
  CREATE_PLAID_LINK: '/obv/plaid/{clientReferenceId}/linkToken',
  CREATE_LINK_EVENT: '/obv/plaid/{clientReferenceId}/linkEvent',
  OBV_VERIFICATION: '/obv/plaid/{clientReferenceId}/verification',
  CONFIRMATION: '/obv/plaid/{clientReferenceId}/confirmation',
  EXIT_BANK: '/obv/plaid/{clientReferenceId}/exitEvent'
}

export default URLs;
